<!--マイナンバー申請-->
<template>
  <div>
    <div style="background-color:#fafafa; margin-top:8px">
      <el-row :gutter="0" style="">
        <!-- 本人マイナンバー申請 -->
        <div class="table-header"><span>{{$t('MODULE.I0006_LBL_TITLE')}}</span></div>
        <table class="i0006-table">
          <!-- 申請(12桁) -->
          <tr style="width:100%">
            <td class="i0006-form-label" style="line-height:30px">
              {{$t('MODULE.I0006_LBL_LABEL1')}}
            </td>
            <td class="i0006-input-value">
              <el-input style="width:89%;font-size:12px" v-model="applySaveParams.myNo" @change="MynoChange()" maxlength="12" pattern="\d*" @input="applySaveParams.myNo = applySaveParams.myNo.replace(/[^\d]/g, '');"></el-input>
              <span style="color:red;font-size:15px">＊</span>
            </td>
          </tr>
          <!-- 確認(12桁) -->
          <tr style="width:100%">
            <td class=" i0006-form-label" style="line-height:30px">
              <span>{{$t('MODULE.I0006_LBL_LABEL2')}}</span>
            </td>
            <td class="i0006-input-value">
              <el-input style="width:89%;font-size:12px" v-model="myNumberAffirm" maxlength="12" pattern="\d*" @input="myNumberAffirm = myNumberAffirm.replace(/[^\d]/g, '');"></el-input>
              <span style="color:red;font-size:15px">＊</span>
            </td>
          </tr>
        </table>
      </el-row>
    </div>
    <div style="background-color:#fafafa; margin-top:3px">
      <el-row :gutter="0" style="">
        <!-- 本人確認 -->
        <div class="table-header"><span>{{$t('MODULE.I0006_LBL_SELF_CONFIRM')}}</span></div>
        <table class="i0006-table">
          <!-- 確認資料 -->
          <tr style="width:100%">
            <td class="i0006-form-label">{{$t('MODULE.I0006_LBL_DATA_CONFIRM')}}</td>
            <td class="i0006_select_value">
              <el-select v-model="myNoCfmDivValue" @change="select(myNoCfmDivValue)" style="width:91%;">
                <el-option v-for="item in myNoCfmDivlist" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
              <span style="color:red;font-size:15px">＊</span>
            </td>
          </tr>
        </table>
      </el-row>
      <div style="border:1px solid #ccc;border-top:none">
        <table class="i0006-upload-table">
          <tr>
            <!-- 表面 -->
            <td class="i0006-form-photolabel" style="" v-html="$t('MODULE.I0006_LBL_FRONT_SIDE')" />
            <td class="i0006-form-value">
              <div class="div_input_i0006">
                <div class="i0006_photo_border" v-if="!applySaveParams.myNoPhoto1"></div>
                <span style="color:red;float:right;margin-top:15px;margin-right:2px;font-size:15px">＊</span>
                <el-upload class="i0006_photo_upload" ref="backside1" :file-list="backside1ImageList" :show-file-list="true" list-type="picture-card" :limit="2" accept=".jpg,.gif,.png,.bmp,.jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'backside1','1')}" :auto-upload="false" multiple>
                  <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                  <template slot="file" slot-scope="{file}">
                    <img id="backside1Img" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'backside1')">
                      <span v-if="backside1LongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'backside1','1')}">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </template>
                </el-upload>
                <!--图片预览用dialog-->
                <el-image-viewer v-if="backside1Dialog" :on-close="backside1PhotoDelete" :url-list="[backside1Url]" />
              </div>
            </td>
          </tr>
          <tr v-show="pageShow">
            <!-- 裏面 -->
            <td class="i0006-form-photolabel">{{$t('MODULE.I0006_LBL_BACK_SIDE')}}</td>
            <td class="i0006-form-value">
              <div class="div_input_i0006">
                <div class="i0006_photo_border" v-if="!applySaveParams.myNoPhoto2"></div>
                <span style="color:red;float:right;margin-top:15px;margin-right:2px;font-size:15px">＊</span>
                <el-upload class="i0006_photo_upload" ref="backside2" :file-list="backside2ImageList" :show-file-list="true" list-type="picture-card" :limit="2" accept=".jpg,.gif,.png,.bmp,.jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'backside2','2')}" :auto-upload="false" multiple>
                  <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
                  <template slot="file" slot-scope="{file}">
                    <img id="backside2Img" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'backside2')">
                      <span v-if="backside1LongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'backside2','2')}">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </template>
                </el-upload>
                <!--图片预览用dialog-->
                <el-image-viewer v-if="backside2Dialog" :on-close="backside2PhotoDelete" :url-list="[backside2Url]" />
              </div>
            </td>
          </tr>
        </table>
        <!-- ※裏面に何も記載無くても、記載なしの証明として必要です -->
        <p v-show="pageShow" class="i0006_MSG" style="font-size:13px;color:red;margin-bottom:0px">{{$t('MODULE.I0006_LBL_TEXT')}}</p>
        <!-- <p v-show="pageShow"></p> -->
      </div>
    </div>
    <tr v-show="processCdShow">
      <!-- 申請状态 -->
      <td>
        <p style="font-size:13px" v-html="statusName"></p>
      </td>
      <!-- 申請日时 -->
      <td>
        <p style="font-size:13px;padding-left:10px" v-html="statusDate"></p>
      </td>
    </tr>
    <div align="center" style=" margin-top:3px">
      <!-- 申請按钮 -->
      <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 13px;width:20%;" @click="i0006ApplicationOnClick()" :disabled="ApplyCheck">{{$t('MODULE.I0006_LBL_APPLY')}}</el-button>
      <!-- 戻る按钮 -->
      <el-button v-show="ButtonShow" class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 13px;width:20%" @click="back_click()">{{$t('MODULE.I0006_LBL_BACK')}}</el-button>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0006"
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  mixins: [css],
  components: {
    ElImageViewer
  },
  data() {
    return {
      ApplyCheck: false,
      backside1ImageList: [],
      backside2ImageList: [],
      backside1Url: '',
      backside2Url: '',
      backside1Btn: true,
      backside2Btn: true,
      applyDate: '',
      confirmDate: '',
      statusDate: '',
      statusFatDate: '',
      backside1Css: true,
      myNoCfmDivlist: [],
      myNoCfmDiv: '',
      tableData: [],
      photoList: {},
      myNoPhoto1: false,
      myNoPhoto2: false,
      myNo: '',
      pageShow: true,
      ButtonShow: '',
      i0005UsedNum: '',
      processCdNum: '',
      statusNum: '',
      statusName: '',
      processCdShow: '',
      myNumber: '',
      myNumberAffirm: '',
      backside1Dialog: false,
      backside2Dialog: false,
      backside1LongClick: false,
      backside2LongClick: false,
      value: '',
      myNoCfmDivValue: '',
      changeFlg: false,
      applySaveParams: {
        userCd: '',
        myNo: '',
        myNoCfmDiv: '',
        myNoPhoto1: '',
        myNoPhoto2: '',
        processCd: '',
        id: '',
        updateDate: ''
      },
      photoNum: '',
      photoUpdateList: [],
      SaveParams: []
    };
  },
  created() {
    // login-User
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
    this.myNoCfmDiv_select()

  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.imageLongClick = false;
        that.backside1LongClick = false//是否为图片长按模式（true=长按模式）。
        that.backside2LongClick = false//是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        //关闭照片查看器
        that.backside1Dialog = false
        that.backside2Dialog = false
        that.othersExpensesDialog = false
        that.transportExpensesTripDialog = false
        that.accommodationDialog = false
      }
    })
  },
  methods: {
    // 画像文件之前的钩子
    handleChange(file, fileList, itemName, type) {
      var file_type = file.raw.type
      if (!(file_type === 'image/jpg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        if (this.photoUpdateList.indexOf(type) == -1) {
          this.photoUpdateList.push(type)
        }
        this[itemName + 'imageList'] = []
        this[itemName + 'LongClick'] = false
        if (file.status === "ready") {
          // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
          if (fileList.length === 2) {
            fileList.shift();
          }
        }
        this['myNoPhoto' + type] = true
        // backside2ImageList
        this[itemName + 'imageList'].push(fileList[0])
        this[itemName + 'Url'] = file.url
        //拡張子
        var exhibitionName = file.name.split('.')[1];
        // // 写真パス：「image/personalPhoto/クルーコード/社員ID_店舗役職CD_種別_写真ID.jpg」
        this.applySaveParams['myNoPhoto' + type] = url.imgUrl_UserInfo + this.userCd + '/myno' + '/' + type + '_' + this.getDateTimeToString() + '.' + exhibitionName
        var that = this
        this.getBase64(file.raw).then(async res => {
          // 进行图片压缩获取压缩后的blob文件
          var photo = await that.compressImg(that.base64ToBlob(res))
          let files = new window.File([photo], file.name, { type: file.type })
          this["photo" + type] = files
        })
        this.changeFlg = true;
      }
    },

    // 图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // base转blob
    base64ToBlob(file) {
      let byteString;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1])
      } else {
        byteString = unescape(file.split(',')[1])
      }
      let mimeString = file
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },

    // 压缩图片
    compressImg(file) {
      var that = this
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
              h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files)
          };
        };
      })
    },

    //input入力チェック
    i0006ApplicationOnClick() {
      let re = new RegExp(/\d{12}/);
      if (this.applySaveParams.myNo == null || this.applySaveParams.myNo == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_LABEL1')));
        return
      }
      if (this.myNumberAffirm == null || this.myNumberAffirm == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_LABEL2')));
        return
      }
      if (this.myNoCfmDivValue == null || this.myNoCfmDivValue == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_DATA_CONFIRM')));
        return
      }
      if (this.applySaveParams.myNoPhoto1 == null || this.applySaveParams.myNoPhoto1 == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_FRONTPHOTO_SIDE')));
        return
      }
      if (this.pageShow) {
        if (this.applySaveParams.myNoPhoto2 == null || this.applySaveParams.myNoPhoto2 == '') {
          this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_BACKPHOTO_SIDE')));
          return
        }
      }
      if (this.applySaveParams.myNo.length != 12) {
        this.$message.error(this.$t('COMMON.MSG_MYNO_VALIDITY'));
        return
      }
      if (!re.test(this.applySaveParams.myNo)) {
        this.$message.error(this.$t('MODULE.I0006_ERR_MSG2'));
        return
      }
      if (this.applySaveParams.myNo != this.myNumberAffirm) {
        this.$message.error(this.$t('MODULE.I0006_ERR_MSG3'));
        return
      }
      this.ApplyConfirm()
    },
    //获取时间戳yyyymmddhhmmssfff
    getDateTimeToString() {
      var date_ = new Date();
      var year = date_.getFullYear();
      var month = date_.getMonth() + 1;
      var day = date_.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      var hours = date_.getHours();
      var mins = date_.getMinutes();
      var secs = date_.getSeconds();
      var msecs = date_.getMilliseconds();
      if (hours < 10) hours = "0" + hours;
      if (mins < 10) mins = "0" + mins;
      if (secs < 10) secs = "0" + secs;
      if (msecs < 10) {
        msecs = "00" + msecs;
      } else if (msecs < 100) {
        msecs = "0" + msecs;
      }
      return year.toString() + month.toString() + day.toString() + hours.toString() + mins.toString() + secs.toString() + msecs.toString();
    },
    // 確認資料を取得する。
    myNoCfmDiv_select() {
      var page = 'all'
      var div = '50'
      var type = 'my_no_cfm_div'
      amsApi.conditionSearch(page, div, type).then(res => {
        this.myNoCfmDivlist = res.items.generalData.myNoCfmDiv
        this.myNoInfo_select()
      })
    },
    // 初期値を取得する。
    myNoInfo_select() {
      this.photoInit();
      //实现Loading 加载方法
      this.set_loading()
      amsApi.myNoInfoGet(this.userCd).then(res => {
        this.applySaveParams.myNo = res.items.myNoInfo[0].myNo
        this.applySaveParams.processCd = res.items.myNoInfo[0].processCd
        this.statusName = res.items.myNoInfo[0].statusName
        this.applyDate = res.items.myNoInfo[0].applyDate
        this.confirmDate = res.items.myNoInfo[0].confirmDate
        this.statusNum = res.items.myNoInfo[0].status
        this.myNoCfmDivValue = res.items.myNoInfo[0].myNoCfmDiv
        this.applySaveParams.myNoPhoto1 = res.items.myNoInfo[0].myNoPhoto1
        this.applySaveParams.myNoPhoto2 = res.items.myNoInfo[0].myNoPhoto2
        this.applySaveParams.id = res.items.myNoInfo[0].id
        this.applySaveParams.updateDate = res.items.myNoInfo[0].updateDate
        this.ApplyShow()
        this.ApplyBtnCheck()
        this.statusDateCheck()
        this.BackButtonCheck()
        this.photo2Show(this.myNoCfmDivValue)
        if (this.applySaveParams.myNoPhoto1) {
          this.download_Get(this.applySaveParams.myNoPhoto1, '1')
        }
        if (this.applySaveParams.myNoPhoto2) {
          this.download_Get(this.applySaveParams.myNoPhoto2, '2')
        }
        this.close_loading()
      }).catch((err) => {
        this.close_loading()
      });
    },
    // 戻るボタン活性check
    BackButtonCheck() {
      amsApi.menuStateManagerGet(this.userCd).then(res => {
        this.i0005UsedNum = res.items.menuState[0].i0005Used
        if (this.i0005UsedNum == 1) {
          this.ButtonShow = true
        } else {
          this.ButtonShow = false
        }
      })
    },
    // ステータス&日時、処理区分が「1」の場合は活性
    ApplyShow() {
      if (this.applySaveParams.processCd == 1) {
        this.processCdShow = true
      } else {
        this.processCdShow = false
      }
    },
    // 処理区分が「1：更新」 and  ステータスが「2：確認済」の場合、申請ボタンが非活性する。
    ApplyBtnCheck() {
      if (this.applySaveParams.processCd == 1 && this.statusNum == 2) {
        this.ApplyCheck = true
      }
    },
    // 日時Check
    statusDateCheck() {
      if (this.statusNum == 0) {
        this.statusFatDate = this.applyDate
        this.statusDateFormat(this.statusFatDate)
      } else if (this.statusNum == 1 || this.statusNum == 2) {
        this.statusFatDate = this.confirmDate
        this.statusDateFormat(this.statusFatDate)
      }
    },
    // 写真检索
    download_Get(photoPath, type) {
      this.photoUpdateList = []
      this['backside' + type + 'ImageList'] = []
      amsApi.photoFile_get(photoPath).then(res => {
        let blob = new Blob([res], { type: 'image/jpg' })
        var url = window.URL.createObjectURL(blob)
        this['backside' + type + 'ImageList'].push({ url: url })
        this.close_loading();
      }).catch(() => {
        this.close_loading();
      })
    },

    // 日期删掉毫秒
    statusDateFormat(date) {
      let str = date
      this.statusDate = str.substring(0, 19)
    },

    //確認資料判定
    select(myNoCfmDivValue) {
      if (myNoCfmDivValue == "03") {
        this.pageShow = false
        // if (this.photoUpdateList.length == 2) {
        //   for (var i = 0; i < this.photoUpdateList.length; i++) {
        //     if (this.photoUpdateList[i] == '2') {
        //       this.photoUpdateList.splice(i, 1);
        //     }
        //   }
        //   //this.photoUpdateList.pop()
        // }
      } else {
        this.pageShow = true;
      }
      this.changeFlg = true;
    },
    //初期確認資料判定
    photo2Show(myNoCfmDivValue) {
      if (myNoCfmDivValue == "03") {
        this.pageShow = false;
      } else {
        this.pageShow = true;
      }
    },
    // 申請(12桁)判定
    MynoChange() {
      this.changeFlg = true;
    },
    // 返回按钮点击事件
    back_click() {
      if (this.changeFlg == true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: 'true'
        }).then(() => {
          var vm = this
          vm.$router.push({ path: url.routerUrl_I0005 });
        }).catch(() => { });
      } else {
        var vm = this
        vm.$router.push({ path: url.routerUrl_I0005 });
      }
    },
    //单张图片点击
    handlePictureCardPreview(file, dialogName) {
      if (this[dialogName + 'LongClick'] == true) {
        this[dialogName + 'LongClick'] = false
      } else {
        this[dialogName + 'Url'] = file.url;
        this[dialogName + 'Dialog'] = true;
      }
    },
    //单张图片删除
    fileRemove(file, fileList, itemName, type) {
      this.$refs[itemName].clearFiles()
      this[itemName + "Url"] = ''
      this[itemName + "LongClick"] = false
      this.photoList[type] = ''
    },

    // 照片删除
    backside1PhotoDelete() {
      this.photoDelete('backside1', '1')
    },
    backside2PhotoDelete() {
      this.photoDelete('backside2', '2')
    },

    // 照片检索前数据初始化
    photoInit() {
      this.photoList = {}
      this.backside2ImageList = []
      this.backside1ImageList = []
      this.backside2Url = ''
      this.backside1Url = ''
    },
    // 申請确认
    ApplyConfirm() {
      this.$confirm(this.$t('COMMON.MSG_APPLY_CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(() => {
        this.applyData()
      }).catch(() => {
      })
    },

    // 上传照片数量判定
    applyData() {
      this.photoNum = 0
      // 单张照片排他不上传
      if (!this.myNoPhoto1) {
        this.applySaveParams.myNoPhoto1 = null
      }
      if (!this.myNoPhoto2) {
        this.applySaveParams.myNoPhoto2 = null
      }

      if (this.photoUpdateList.length == 2 && this.myNoCfmDivValue == "03") {
        for (var i = 0; i < this.photoUpdateList.length; i++) {
          if (this.photoUpdateList[i] == '2') {
            this.photoUpdateList.splice(i, 1);
          }
        }
      }
      if (this.photoUpdateList.length > 0) {
        for (var i = 0; i < this.photoUpdateList.length; i++) {
          this.Photo_upload(this.photoUpdateList[i], this.photoUpdateList.length)
        }
      } else {
        this.ApplySave()
      }
    },

    // 写真毎に、API「アップロード」を呼び出す。
    Photo_upload(type, length) {
      let photoFormData = new FormData()
      photoFormData.append('files', this["photo" + type], this.applySaveParams["myNoPhoto" + type])
      this.set_loading()
      amsApi.photoFile_saveImage(photoFormData).then(res => {
        this['myNoPhoto' + type] = false
        if (res.code == 205) {
          this.photoNum += 1
          if (this.photoNum == length) {
            this.ApplySave()
          }
          this.close_loading()
        } else if (res.code == 311) {
          this.close_loading()
          //图片上传失败
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
        }
      }).catch((err) => {
        this.close_loading()
      })
    },

    // 申请保存API
    ApplySave() {
      this.applySaveParams.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
      this.applySaveParams.myNoCfmDiv = this.myNoCfmDivValue
      if (!this.pageShow) {
        this.photo2Delete('backside2', '2')
        this.applySaveParams.myNoPhoto2 = ''
      }
      amsApi.Apply_Save(this.userCd, this.applySaveParams).then(res => {
        if (res.code == '202') {
          this.changeFlg = false
          this.$message.success({ message: this.$t('COMMON.MSG_INSERTED'), showClose: true });//保存成功
          this.myNoInfo_select()
        } else if (res.code == '311') {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        } else if (res.code == '308') {
          // 処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), this.$t('COMMON.CONFIRM'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
            center: 'true'
          }).then(() => {
            // 画面刷新
            this.myNoInfo_select()
          }).catch(() => {
          });
        }
      })

    },

    // 删除确认
    photoDelete(itemName, type) {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.BTN_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(() => {
        //组件表示图片清空
        this.$refs[itemName].clearFiles()
        this.applySaveParams['myNoPhoto' + type] = ''
        //上传用list清空
        this[itemName + 'ImageList'] = []
        this[itemName + 'Url'] = ''
        this[itemName + 'Dialog'] = false
        this.photoList[type] = ''
        this.changeFlg = true;
      }).catch(() => {
      })
    },

    // 确认资料key是03时，删除裹面图片
    photo2Delete(itemName, type) {
      //组件表示图片清空
      this.$refs[itemName].clearFiles()
      this.applySaveParams['myNoPhoto' + type] = ''
      //上传用list清空
      this[itemName + 'ImageList'] = []
      this[itemName + 'Url'] = ''
      this[itemName + 'Dialog'] = false
      this.photoList[type] = ''
      this.changeFlg = true;
    }
  }
}

</script>
<style >
/* avatar様式 */
.i0006-avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: default;
  position: relative;
  margin-left: 30px;
  margin-top: 5px;
}
.i0006-avatar-uploader .el-upload:hover {
  border-color: white;
}
.i0006-avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.i0006-avatar {
  width: 178px;
  height: 178px;
  margin-top: 5px;
  display: block;
}
/* form様式 */
.i0006-form-label {
  text-align: right;
  width: 100px;
  background: #d2eef8;
}
.i0006-form-photolabel {
  text-align: right;
  width: 100px;
}
/* 申請ボタン様式 */
.i0006-button.el-button {
  width: 23%;
  margin-top: 10px;
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #fff;
}
/* 選択ボタン様式 */
.i0006-avatar-uploader .el-button {
  width: 130%;
  background-image: linear-gradient(#3cc6fa, #1197ca);
  text-align: center;
  color: #fff;
}
.i0006-button.el-button + .el-button {
  margin-left: 0%;
}
/* title様式 */
.i0006-title {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #fff;
  font-weight: 550;
  font-size: 13px;
  padding: 5px;
  text-align: center;
}
/* 表格边框、字体样式 */
.i0006-table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}

/* 表格边框颜色 */
.i0006-table,
.i0006-table tr td {
  border: 1px solid #ccc;
}
/* 表格内边距 */
.i0006-table td {
  padding: 5px 5px;
}
/* 左边空图片蓝色边框 */
.i0006_photo_border {
  float: left;
  width: 40%;
  height: 40px;
  margin-left: 0px;
  margin-top: 5px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}
.div_input_i0006 .el-icon-circle-close:before {
  color: #fd270a;
}
/* 左边空图片红色边框 */
.backside1Css {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
.i0006_photo_upload .el-upload--picture-card {
  width: 40%;
  height: 43px;
  margin-top: 5px;
  margin-left: 6px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}
.i0006-input-value,
.i0006-input-value tr td {
  padding-right: 0 !important;
}
/* 图片样式 */
.i0006_photo_upload .el-upload-list--picture-card .el-upload-list__item {
  width: 40%;
  height: 43px;
  margin: 5px 0 0 0;
  border: none;
}

/* 图片上传按钮样式 */
.i0006_photo_upload .el-upload--picture-card i {
  margin-top: 5px;
  color: #409eff;
}
/* 去除上传图片动画 */
.i0006_photo_upload .el-upload-list__item {
  transition: none !important;
}
.i0006-upload-table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}
/* 表格内边距 */
.i0006-upload-table td {
  padding: 5px 5px;
}
/* 文字居中 */
.i0006_MSG {
  text-align: center;
}
.i0006_select_value .el-input__inner {
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0006.vue